module.exports = "https://static.wmbcdn.com/uniweb/images/9d56b2d97325a9fc3a4e374f5e7db1e2.svg";